export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }